import { render, staticRenderFns } from "./VipButton.vue?vue&type=template&id=202fae28&"
import script from "./VipButton.vue?vue&type=script&lang=js&"
export * from "./VipButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports